export default "__VITE_ASSET__BkW2QPrf__"